import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { CampaignFormValues } from "src/models/Campaign.model";
import CampaignForm from "../Layouts/CampaignForm";
import {
  useViewCampaignByIdQuery,
  useEditCampaignMutation,
} from "src/services/CampaignServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
type Props = {
  onClose: () => void;
  campaignId: string;
};

const EditCampaignFormWrapper = ({ onClose, campaignId }: Props) => {
  const [campaignData, setCampaignData] = useState<any>();

  const [editCampaign] = useEditCampaignMutation();
  const { data, isLoading, isFetching } = useViewCampaignByIdQuery(campaignId);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setCampaignData(data?.data?.[0]);
    }
  }, [isFetching, isLoading, data]);
  // Form Initial Values
  const initialValues: CampaignFormValues = {
    campaignName: campaignData?.campaignName || "",
    campaignGroupId: campaignData?.campaignGroupId || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    campaignName: string().required("Please campaign name"),
    campaignGroupId: string().required("Please select channel"),
  });

  // Handle Submit
  const handleSubmit = (
    values: CampaignFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CampaignFormValues>
  ) => {
    const formattedValues = {
      campaignName: values?.campaignName,
      campaignGroupId: values?.campaignGroupId,
    };
    editCampaign({
      body: formattedValues,
      id: campaignId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <CampaignForm
              formType="Update"
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditCampaignFormWrapper;
